<template>
    <div class="subscription-priority-view flex-between-wrapper">
      <img class="feature-image" src="/assets/app/class/priority-frame-bg.png">
      <div class="premium-priority-view">
        <h3 class="view-title">Get the support you need, when you need it.</h3>
        <p class="view-description">Your success is our success. Priority support means your support inquiries will always get answered first. Look at us as an extension of your teaching team!</p>
<!--        <ul class="support-features">-->
<!--          <li class="support-feature-item">-->
<!--            <rt-picture src="/assets/app/class/icon-check-blue.svg"></rt-picture>-->
<!--            <span>Password Troubleshooting</span>-->
<!--          </li>-->
<!--          <li class="support-feature-item">-->
<!--            <rt-picture src="/assets/app/class/icon-check-blue.svg"></rt-picture>-->
<!--            <span>Resolving Duplciate Accounts</span>-->
<!--          </li>-->
<!--          <li class="support-feature-item">-->
<!--            <rt-picture src="/assets/app/class/icon-check-blue.svg"></rt-picture>-->
<!--            <span>Class Creation and Account Creation</span>-->
<!--          </li>-->
<!--          <li class="support-feature-item">-->
<!--            <rt-picture src="/assets/app/class/icon-check-blue.svg"></rt-picture>-->
<!--            <span>Site Functionality Questions</span>-->
<!--          </li>-->
<!--          <li class="support-feature-item">-->
<!--            <rt-picture src="/assets/app/class/icon-check-blue.svg"></rt-picture>-->
<!--            <span>Whole School Account Creation</span>-->
<!--          </li>-->
<!--        </ul>-->
        <div class="button-wrapper">
          <primary-button @click="handleClickPlan">Choose your plan</primary-button>
        </div>
      </div>
    </div>
</template>

<script>

import RtPicture from '../../common/Picture.vue';
import PrimaryButton from '../../common/PrimaryButton.vue';

export default {
  components: {
    RtPicture,
    PrimaryButton
  },
  methods: {
    handleClickPlan() {
      this.$emit('showPlan');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../common/variables';

.subscription-priority-view {
  padding-top: 128px;
  .feature-image {
    margin-top: -20px;
    margin-right: 10px;
  }
  .premium-priority-view {
    max-width: 397px;
  }
  .support-features {
    list-style: none;
    padding-top: 25px;
    .support-feature-item {
      display: flex;
      align-items: center;
      padding-top: 16px;
      &:first-child {
        padding: 0;
      }
      .rt-picture {
        margin-right: 12px;
      }
      span {
        font-size: 14px;
        color: $title-grey;
      }
    }
  }
  @media(max-width: 900px) {
    display: block;
    padding-top: 50px;
    .feature-image {
      margin-right: 0;
    }
    .premium-priority-view {
      max-width: none;
      margin-top: 20px;
    }
  }
}
</style>
